import React, { useState, useEffect } from "react";
import Select from "react-select";
import PropTypes from "prop-types";

export default function UiCustomerSelect(props) {
    const [selectedValue, setSelectedValue] = useState(null);

    useEffect(() => {
        if (selectedValue === null && props.defaultValue) {
            setSelectedValue(props.defaultValue);
        }
    }, [props.defaultValue, selectedValue]);

    const handleChange = (value) => {
        setSelectedValue(value);
        if (props.onChange) {
            props.onChange(value);
        }
    };

    const colorStyles = {
        placeholder: (defaultStyles) => {
            return {
                ...defaultStyles,
                color: "#B1B5C3",
            };
        },
    };

    return (
        <div className="sb-customer-select-wr">
            <label>{props.label}</label>
            <Select
                onChange={handleChange}
                className="sb-mobile-single"
                classNamePrefix="select"
                styles={colorStyles}
                placeholder={props.placeholder}
                options={props.options}
                value={props.defaultValue}
               // defaultValue={props?.defaultValue ? props?.defaultValue : []}
            />
        </div>
    );
}

UiCustomerSelect.propTypes = {
    label: PropTypes.string,
};
